import { FormControl, FormLabel, Stack, Switch } from '@mui/joy';

import { ExpandableErrorAlert } from '@/components/ExpandableErrorAlert';
import { Message } from '@/components/Message';
import { FancyRenderingProvider } from '@/components/RichTextEditor/utils/fancyRenderContext';
import { useFancyRendering } from '@/components/RichTextEditor/utils/fancyRenderContext/useFancyRender';
import { RunSchema } from '@/types/schema';
import { getTopLevelError } from '@/utils/stringUtils';

import { RunOutput } from '../Run/components/RunOutput';
import { getPlaygroundChainOutput } from './PlaygroundChainOutput.utils';
import { usePlaygroundParentContext } from './context/PlaygroundParentContext';

function PlaygroundChainOutputInner(props: {
  isInputHidden?: boolean;
  run?: RunSchema | null;
}) {
  const { isSimplified } = usePlaygroundParentContext();
  const input = props.run?.inputs ?? {};
  const output = getPlaygroundChainOutput(props.run);

  const { fancyRendering, setFancyRendering } = useFancyRendering();

  if (props.run?.error) {
    return <ExpandableErrorAlert error={getTopLevelError(props.run.error)} />;
  }

  return (
    <div className="flex flex-col gap-3">
      {!isSimplified && (
        <div className="flex">
          <FormControl orientation="horizontal">
            <FormLabel>Fancy rendering</FormLabel>
            <Switch
              title="Fancy rendering"
              checked={fancyRendering}
              onChange={() => setFancyRendering(!fancyRendering)}
              size="sm"
            />
          </FormControl>
        </div>
      )}

      <Stack gap={2}>
        {!props.isInputHidden && (
          <Message role="Input" content="" kwargs={input} omitMaxHeight />
        )}

        <RunOutput outputs={output} />
      </Stack>
    </div>
  );
}

export function PlaygroundChainOutput(props: {
  isInputHidden?: boolean;
  run?: RunSchema | null;
}) {
  return (
    <FancyRenderingProvider>
      <PlaygroundChainOutputInner {...props} />
    </FancyRenderingProvider>
  );
}
